import { render, staticRenderFns } from "./detailsDrawer.vue?vue&type=template&id=3a97aa32&scoped=true&"
import script from "./detailsDrawer.vue?vue&type=script&lang=js&"
export * from "./detailsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./detailsDrawer.vue?vue&type=style&index=0&id=3a97aa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97aa32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a97aa32')) {
      api.createRecord('3a97aa32', component.options)
    } else {
      api.reload('3a97aa32', component.options)
    }
    module.hot.accept("./detailsDrawer.vue?vue&type=template&id=3a97aa32&scoped=true&", function () {
      api.rerender('3a97aa32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/battery/dialog/detailsDrawer.vue"
export default component.exports